import React, { useState } from 'react'
import ImageCard from './ImageCard'
import ImageEditor from './ImageEditor'
import FileUpload from '../_shared/FileUpload'
import { useInitializeSelectedImages } from './useInitializeSelectedImages'
import { useArticleContext } from '../_core'
import { useFilesUploader } from '../_shared/useFilesUploader'
import { UploadTargetType } from '../_shared/image-upload.services'
import { COVER_IMAGE } from '../_shared/ImageConstant'

const DEFAULT_MAX_IMAGE_COUNT = 1

interface ImageUploadProps {
  onImageUpload: (...args: any[]) => void
  onImageEdit: (...args: any[]) => void
  onImageDelete: (...args: any[]) => void
  handleImageFile: (...args: any[]) => Promise<unknown>
  maxImageCount?: number
  onImageUploadStart?: () => void
  onImageUploadEnd?: () => void
}

function ImageUpload({
  onImageUpload,
  onImageEdit,
  onImageDelete,
  handleImageFile,
  maxImageCount = DEFAULT_MAX_IMAGE_COUNT,
  onImageUploadStart,
  onImageUploadEnd,
}: ImageUploadProps) {
  const { updateImageIds, updateCoverImageId, articleState } = useArticleContext()
  const [currentImageId, setCurrentImageId] = useState(null)
  const [imageEditorVisibility, setImageEditorVisibility] = useState(false)

  const { selectedImages, setSelectedImages } = useInitializeSelectedImages()

  const useFilesHandlerInput = {
    selectedFiles: selectedImages,
    setSelectedFiles: setSelectedImages,
    imageType: COVER_IMAGE,
    maxImageCount,
    onImageAction: onImageUpload,
    target: UploadTargetType.ARTICLE_IMAGES,
  }
  const { handleFiles } = useFilesUploader(useFilesHandlerInput)

  const renderChild = () => {
    const image = selectedImages?.[0]
    if (!image) return
    return (
      <ImageCard
        data={image}
        setSelectedImages={setSelectedImages}
        setImageEditorVisibility={setImageEditorVisibility}
        handleFiles={handleFiles}
        onImageEdit={onImageEdit}
        handleImageFile={handleImageFile}
        articleState={articleState}
        updateImageIds={updateImageIds}
      />
    )
  }

  return (
    <div>
      <FileUpload
        inputId="article-cover-image-input"
        onImageUpload={onImageUpload}
        maxImageCount={maxImageCount}
        onImageUploadStart={onImageUploadStart}
        onImageUploadEnd={onImageUploadEnd}
        child={renderChild()}
        selectedFiles={selectedImages}
        setSelectedFiles={setSelectedImages}
        imageType={COVER_IMAGE}
        target={UploadTargetType.ARTICLE_IMAGES}
        isChangeable={true}
        hoverEffect={true}
      />

      {imageEditorVisibility && (
        <ImageEditor
          currentImageId={currentImageId}
          selectedImages={selectedImages}
          setSelectedImages={setSelectedImages}
          setCurrentImageId={setCurrentImageId}
          onImageEdit={onImageEdit}
          handleImageFile={handleImageFile}
          visibility={imageEditorVisibility}
          setVisibility={setImageEditorVisibility}
        />
      )}
    </div>
  )
}

export default ImageUpload
